"use strict";

var _objectSpread = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var mui_1 = require("tss-react/mui");
var Launch_1 = __importDefault(require("@mui/icons-material/Launch"));
var mobx_react_1 = require("mobx-react");
// ui elements
var DrawerWidget_1 = __importDefault(require("./DrawerWidget"));
var AppToolbar_1 = __importDefault(require("./AppToolbar"));
var Snackbar_1 = __importDefault(require("./Snackbar"));
var ViewLauncher_1 = __importDefault(require("./ViewLauncher"));
var ViewPanel_1 = __importDefault(require("./ViewPanel"));
var useStyles = (0, mui_1.makeStyles)()(function (theme) {
  return {
    root: {
      fontFamily: 'Roboto',
      display: 'grid',
      height: '100vh',
      width: '100%',
      colorScheme: theme.palette.mode
    },
    fabLeft: {
      zIndex: 10000,
      position: 'fixed',
      bottom: theme.spacing(2),
      left: theme.spacing(2)
    },
    fabRight: {
      zIndex: 10000,
      position: 'fixed',
      bottom: theme.spacing(2),
      right: theme.spacing(2)
    },
    menuBarAndComponents: {
      gridColumn: 'main',
      display: 'grid',
      gridTemplateRows: '[menubar] min-content [components] auto',
      height: '100vh'
    },
    menuBar: {
      gridRow: 'menubar'
    },
    components: {
      overflowY: 'auto',
      gridRow: 'components'
    },
    appBar: {
      flexGrow: 1
    }
  };
});
var App = (0, mobx_react_1.observer)(function (props) {
  var session = props.session;
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  var minimized = session.minimized,
    visibleWidget = session.visibleWidget,
    drawerWidth = session.drawerWidth,
    activeWidgets = session.activeWidgets,
    views = session.views,
    drawerPosition = session.drawerPosition;
  var drawerVisible = visibleWidget && !minimized;
  var grid;
  if (drawerPosition === 'right') {
    grid = ["[main] 1fr", drawerVisible ? "[drawer] ".concat(drawerWidth, "px") : undefined];
  } else if (drawerPosition === 'left') {
    grid = [drawerVisible ? "[drawer] ".concat(drawerWidth, "px") : undefined, "[main] 1fr"];
  }
  return react_1.default.createElement("div", {
    className: classes.root,
    style: {
      gridTemplateColumns: grid === null || grid === void 0 ? void 0 : grid.filter(function (f) {
        return !!f;
      }).join(' ')
    }
  }, drawerVisible && drawerPosition === 'left' ? react_1.default.createElement(DrawerWidget_1.default, {
    session: session
  }) : null, session.DialogComponent ? react_1.default.createElement(react_1.Suspense, {
    fallback: react_1.default.createElement("div", null)
  }, react_1.default.createElement(session.DialogComponent, _objectSpread({}, session.DialogProps))) : null, react_1.default.createElement("div", {
    className: classes.menuBarAndComponents
  }, react_1.default.createElement("div", {
    className: classes.menuBar
  }, react_1.default.createElement(material_1.AppBar, {
    className: classes.appBar,
    position: "static"
  }, react_1.default.createElement(AppToolbar_1.default, _objectSpread({}, props)))), react_1.default.createElement("div", {
    className: classes.components
  }, views.length ? views.map(function (view) {
    return react_1.default.createElement(ViewPanel_1.default, {
      key: "view-".concat(view.id),
      view: view,
      session: session
    });
  }) : react_1.default.createElement(ViewLauncher_1.default, _objectSpread({}, props)), react_1.default.createElement("div", {
    style: {
      height: 300
    }
  }))), activeWidgets.size > 0 && minimized ? react_1.default.createElement(material_1.Tooltip, {
    title: "Open drawer widget"
  }, react_1.default.createElement(material_1.Fab, {
    className: drawerPosition === 'right' ? classes.fabRight : classes.fabLeft,
    color: "primary",
    "data-testid": "drawer-maximize",
    onClick: function onClick() {
      return session.showWidgetDrawer();
    }
  }, react_1.default.createElement(Launch_1.default, null))) : null, drawerVisible && drawerPosition === 'right' ? react_1.default.createElement(DrawerWidget_1.default, {
    session: session
  }) : null, react_1.default.createElement(Snackbar_1.default, {
    session: session
  }));
});
exports.default = App;